import React from "react";

const ViewMore = ({ style, onClick }) => {
  return (
    <div
      style={{
        marginTop: 20,
        display: "flex",
        height: 50,
        width: "100%",
        cursor: "pointer",
        alignItems: "center",
        justifyContent: "center",
        gap: 3,
        ...style,
      }}
      onClick={onClick}
    >
      <span
        style={{
          color: "#aaa",
          fontSize: 16,
          fontWeight: 700,
          lineHeight: "140%",
        }}
      >
        더보기
      </span>
      <img src="/assets/admin/icons/ico_select_arrow_down.svg" alt="더보기" />
    </div>
  );
};

export default ViewMore;
